import { FlexColumn } from "@opensea/ui-kit"

type ActivityFeedProps = {
  children: React.ReactNode
}

export function ActivityFeed({ children }: ActivityFeedProps) {
  return <FlexColumn className="size-full min-w-0 grow">{children}</FlexColumn>
}
